import { render, staticRenderFns } from "./GuppyChatSidebarSettingPopup.vue?vue&type=template&id=5db4758e&"
import script from "./GuppyChatSidebarSettingPopup.vue?vue&type=script&lang=js&"
export * from "./GuppyChatSidebarSettingPopup.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatSidebarSettingPopup.vue?vue&type=style&index=0&id=5db4758e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports